import * as React from 'react';
import AutomaticRepliesFull from './components/AutomaticRepliesFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import isAutomaticRepliesOptionDirty from './utils/isAutomaticRepliesOptionDirty';
import discardAutomaticRepliesOption from './data/mutators/discardAutomaticRepliesOption';
import saveAutomaticRepliesOption from './orchestration/saveAutomaticRepliesOption';
var AutomaticRepliesOption = {
    key: 'automaticRepliesOption',
    titleStringKey: 'optionSubcategory_automaticReplies',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionSearchTerms_automaticReplies',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AutomaticRepliesFull, null); },
        isDirty: isAutomaticRepliesOptionDirty,
        onSave: saveAutomaticRepliesOption,
        onDiscard: discardAutomaticRepliesOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('cal-automatic-replies'); },
};
export default AutomaticRepliesOption;
//# sourceMappingURL=AutomaticRepliesOption.js.map